import React from "react";
import { PlainTextField } from "@td/ui";
import { translate } from "@td/shared_utils";
import { fieldTypes } from "../constants";

const ProviderField = React.memo(() => (
  <PlainTextField
    name={fieldTypes.PROVIDER}
    label={`${translate(null, "care_team_tasks.form.fields.provider", "label")}:`}
  />
));

export default ProviderField;
